import React from 'react';

const ProjectDrawingOfficeWorkPackagesIndex = React.lazy(() => import("./index"))
const NewProjectDrawingOfficeWorkPackages = React.lazy(() => import("./new"))
const EditProjectDrawingOfficeWorkPackages = React.lazy(() => import("./edit"))
const ShowProjectDrawingOfficeWorkPackages = React.lazy(() => import("./show"))

export default[
	{path:'/project/drawing_office/work_packages/:id/edit',component: EditProjectDrawingOfficeWorkPackages,name:'Edit ProjectDrawingOfficeWorkPackage'},
	{path:'/project/drawing_office/work_packages/new',component: NewProjectDrawingOfficeWorkPackages,name:'New ProjectDrawingOfficeWorkPackage'},
	{path:'/project/drawing_office/work_packages/:id',component: ShowProjectDrawingOfficeWorkPackages,name:'Show ProjectDrawingOfficeWorkPackage'},
	{path:'/project/drawing_office/work_packages',component: ProjectDrawingOfficeWorkPackagesIndex,name:'ProjectDrawingOfficeWorkPackages'},
]

// import ProjectDrawingOfficeWorkPackagesRoutes from "modules/project/drawing_office/work_packages/web/routes"
// routes = _.concat(routes,ProjectDrawingOfficeWorkPackagesRoutes)
